import React from "react";

import {  injectIntl } from "react-intl";

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";

import TGrid from "../../partials/content/Grid";
import { editOrderStatus } from "../../crud/auth.crud";

import 'date-fns';

import { SketchPicker } from 'react-color'



const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
};





class EditOrderStatus extends React.Component {
  state = {
    
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    selDate:new Date('2014-08-18T21:11:54'),
    statusList:{},
  }



  


constructor(props)
{
  super(props);
    this.state = {
      menu: false,
     
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      locading:false,
      statusColor:'alert-success',
 
      
    };

    


    
  
}
  
  
  handleChangeComplete = (color) => {
    this.setState({ background: color.hex });
  };

  componentDidMount()
  {
    
    if(this.props.location.data.status!=null)
    {

      console.log("status:::",this.props.location.data.status);
      this.setState({statusList:this.props.location.data.status});
      this.setState({background:this.props.location.data.status.orderStatusColor});
    }
     
  }

  



  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;
    return (
      <>

          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}
          {this.state.statusList!=null &&
           <Formik
                  initialValues={{
                    orderStatusColor:this.state.statusList.orderStatusColor,
                    orderStatusName:this.state.statusList.orderStatusName,
                    statusDescription:this.state.statusList.statusDescription,
                  }}
                  validate={values => {
                    const errors = {};
            
                    if (!values.orderStatusName) {
                      errors.orderStatusName = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (this.state.background===null || this.state.background===undefined) {
                      errors.orderStatusColor = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.statusDescription) {
                      errors.statusDescription = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {
                    if(this.state.background!==null &&  this.state.background!==undefined &&  this.state.background!=="")
                    {
                    this.setState({loading:true});
                    let tStatus = this.state.statusList;
                    tStatus.orderStatusColor = this.state.background;
                    tStatus.orderStatusName = values.orderStatusName;
                    tStatus.statusDescription = values.statusDescription;
                    editOrderStatus(
                      tStatus.id,
                      tStatus
                    )
                      .then(resp => {
                        //props.register(accessToken);
                        this.setState({status:true,
                        statusMessage:'Status updated successfully',
                        alertType:'alert-success',loading:false});
                         window.scrollTo(0,0);
                        
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                    }
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
          
                      
        	
      		<TGrid beforeCodeTitle="Status Details" jsCode="false">
        	<div className="kt-section">
	        	<div className="kt-section__content">
           

		   			
		   			<div className="row">
		   			          

                      <div className="col-12">
                        <TextField
                          margin="normal"
                          label="Status Name"
                          className="kt-width-full"
                          name="orderStatusName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.orderStatusName}
                          helperText={touched.orderStatusName && errors.orderStatusName}
                          error={Boolean(touched.orderStatusName && errors.orderStatusName)}
                        />
                      </div>        

                      <div className="col-12">
                        <TextField
                          margin="normal"
                          label="Description"
                          className="kt-width-full"
                          name="statusDescription"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.statusDescription}
                          helperText={touched.statusDescription && errors.statusDescription}
                          error={Boolean(touched.statusDescription && errors.statusDescription)}
                        />
                      </div>      

                     

                      

                      <div className="col-12">
                        <TextField
                          margin="normal"
                          className="kt-width-full"
                          name="orderStatusColor"
                          onChange={handleChange}
                          value={this.state.background}
                          helperText={touched.orderStatusColor && errors.orderStatusColor}
                          error={Boolean(touched.orderStatusColor && errors.orderStatusColor)}

                        />
                      </div>
                       <div className="col-12">

                        <SketchPicker
                            color={ this.state.background }
                            onChangeComplete={ this.handleChangeComplete }
                          />
                      </div>
                      
		   			  </div>
             
             
				   
			    </div>
		    </div>
		    </TGrid>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Update
                        </button>
                      </div>
       </form>
            )}
            </Formik>
          }
       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(EditOrderStatus));

